import React, { useState, useEffect, useRef } from 'react';
import { Image } from 'react-bootstrap';
import T3T4Img from '../images/T3T4_old.png';
import T7T8Img from '../images/T7T8_old.png';

const BrainDiagram = ({ formData, onCalculatedValues }) => {
  const [showInputs, setShowInputs] = useState(true);
  const [updateTimestamp, setUpdateTimestamp] = useState('');
  const nomenclature = formData?.nomenclature === 'T7/T8' ? 1 : 0;
  const [layout, setLayout] = useState({ width: 0, height: 0 });
  const [calculatedValues, setCalculatedValues] = useState({});
  const prevValuesRef = useRef(null);

  useEffect(() => {
    const { nasionToInion, preauricular, circumference } = formData || {};

    const isValid =
      parseFloat(nasionToInion) > 0 &&
      parseFloat(preauricular) > 0 &&
      parseFloat(circumference) > 0;

    const round = (val) => Math.round(val * 10) / 10;

    let newValues;

    if (!isValid) {
      newValues = Object.fromEntries(
        [
          'nasion', 'inion', 'fpz', 'fz', 'cz', 'pz', 'oz',
          't7', 'c3', 'c4', 't8', 'c1', 'c2',
          'fp1', 'fp2', 'f3', 'f4', 'f7', 'f8',
          'p3', 'p4', 'p7', 'p8', 'o1', 'o2'
        ].map(k => [k, 0.0])
      );
    } else {
      newValues = {
        nasion: round(nasionToInion * 0.1),
        inion: round(nasionToInion * 0.1),
        fpz: round(nasionToInion * 0.2),
        fz: round(nasionToInion * 0.2),
        cz: round(nasionToInion * 0.2),
        pz: round(nasionToInion * 0.2),
        oz: round(nasionToInion * 0.1),
        t7: round(preauricular * 0.1),
        c3: round(preauricular * 0.2),
        c4: round(preauricular * 0.2),
        t8: round(preauricular * 0.1),
        c1: round(preauricular * 0.2),
        c2: round(preauricular * 0.2),
        fp1: round(circumference * 0.05),
        fp2: round(circumference * 0.05),
        f3: round(circumference * 0.1),
        f4: round(circumference * 0.1),
        f7: round(circumference * 0.1),
        f8: round(circumference * 0.1),
        p3: round(circumference * 0.1),
        p4: round(circumference * 0.1),
        p7: round(circumference * 0.1),
        p8: round(circumference * 0.1),
        o1: round(circumference * 0.05),
        o2: round(circumference * 0.05),
      };
    }

    const valuesChanged =
      JSON.stringify(prevValuesRef.current) !== JSON.stringify(newValues);

    if (valuesChanged) {
      prevValuesRef.current = newValues;
      setCalculatedValues(newValues);
      setUpdateTimestamp(
        new Date().toLocaleString('en-US', {
          weekday: 'long',
          year: 'numeric',
          month: 'long',
          day: 'numeric',
          hour: 'numeric',
          minute: '2-digit',
          second: '2-digit',
          hour12: true,
        })
      );
      if (onCalculatedValues) {
        onCalculatedValues(newValues);
      }
    }
  }, [formData]);

  const pointMap = {
    nasion: { top: 0.130, left: 0.507 },
    fpz: { top: 0.265, left: 0.505 },
    fz: { top: 0.435, left: 0.510 },
    cz: { top: 0.604, left: 0.510 },
    pz: { top: 0.775, left: 0.510 },
    oz: { top: 0.910, left: 0.507 },
    t7: { top: 0.530, left: 0.03 },
    c3: { top: 0.523, left: 0.198 },
    c4: { top: 0.523, left: 0.825 },
    t8: { top: 0.530, left: 0.990 },
    c1: { top: 0.523, left: 0.409 },
    c2: { top: 0.523, left: 0.615 },
    fp1: { top: 0.18, left: 0.440 },
    fp2: { top: 0.18, left: 0.58 },
    f3: { top: 0.237, left: 0.25 },
    f4: { top: 0.236, left: 0.765 },
    f7: { top: 0.422, left: 0.124 },
    f8: { top: 0.415, left: 0.895 },
    p3: { top: 0.808, left: 0.25 },
    p4: { top: 0.805, left: 0.765 },
    p7: { top: 0.628, left: 0.105 },
    p8: { top: 0.627, left: 0.920 },
    o1: { top: 0.865, left: 0.440 },
    o2: { top: 0.865, left: 0.575 },
  };

  const handleImageLoad = (e) => {
    const { width, height } = e.target;
    setLayout({ width, height });
  };

  return (
    <div className={!showInputs ? 'brain-section' : ''}>
      {/* Timestamp shown only if needed */}
      {/* {updateTimestamp && (
        <h5 className="text-center mb-2" style={{ color: 'red' }}>
          Last Updated: {updateTimestamp}
        </h5>
      )} */}
      <div className="brain-wrapper" style={{ position: 'relative' }}>
        <Image
          alt="Brain Diagram"
          className="brain-image"
          src={nomenclature === 0 ? T3T4Img : T7T8Img}
          onLoad={handleImageLoad}
        />
        {layout.width > 0 &&
          Object.entries(pointMap).map(([key, pos]) => (
            <input
              key={key}
              type="text"
              className={`distance-input pos-${key} ${calculatedValues[key] === 0.0 ? 'input-red' : ''}`}
              value={
                calculatedValues[key] !== undefined
                  ? calculatedValues[key].toFixed(1)
                  : ''
              }
              style={{
                position: 'absolute',
                top: `calc(${pos.top * 100}% - 4px)`,
                left: `calc(${pos.left * 100}% - 2px)`,
              }}
              readOnly
            />
          ))}
      </div>
    </div>
  );
};

export default BrainDiagram;


// import React, { useState, useEffect } from 'react';
// import { Image } from 'react-bootstrap';
// import T3T4Img from '../images/T3T4.png';
// import T7T8Img from '../images/T7T8.png';

// const BrainDiagram = ({ formData, onCalculatedValues }) => {
//   const [showInputs, setShowInputs] = useState(true);
//   const [updateTimestamp, setUpdateTimestamp] = useState('');
//   const nomenclature = formData?.nomenclature === 'T7/T8' ? 1 : 0;
//   const [layout, setLayout] = useState({ width: 0, height: 0 });
//   const [calculatedValues, setCalculatedValues] = useState({
//     nasion: 0.0,
//     inion: 0.0,
//     fpz: 0.0,
//     fz: 0.0,
//     cz: 0.0,
//     pz: 0.0,
//     oz: 0.0,
//     t7: 0.0,
//     c3: 0.0,
//     c4: 0.0,
//     t8: 0.0,
//     c1: 0.0,
//     c2: 0.0,
//     fp1: 0.0,
//     fp2: 0.0,
//     f3: 0.0,
//     f4: 0.0,
//     f7: 0.0,
//     f8: 0.0,
//     p3: 0.0,
//     p4: 0.0,
//     p7: 0.0,
//     p8: 0.0,
//     o1: 0.0,
//     o2: 0.0,
//   });

//   useEffect(() => {
//     const { nasionToInion, preauricular, circumference } = formData || {};

//     const isValid =
//       parseFloat(nasionToInion) > 0 &&
//       parseFloat(preauricular) > 0 &&
//       parseFloat(circumference) > 0;

//     if (!isValid) {
//       const zeroValues = {
//         nasion: 0.0,
//         inion: 0.0,
//         fpz: 0.0,
//         fz: 0.0,
//         cz: 0.0,
//         pz: 0.0,
//         oz: 0.0,
//         t7: 0.0,
//         c3: 0.0,
//         c4: 0.0,
//         t8: 0.0,
//         c1: 0.0,
//         c2: 0.0,
//         fp1: 0.0,
//         fp2: 0.0,
//         f3: 0.0,
//         f4: 0.0,
//         f7: 0.0,
//         f8: 0.0,
//         p3: 0.0,
//         p4: 0.0,
//         p7: 0.0,
//         p8: 0.0,
//         o1: 0.0,
//         o2: 0.0,
//       };
//       setCalculatedValues(zeroValues);
//       setUpdateTimestamp('');
//       if (onCalculatedValues) {
//         onCalculatedValues(zeroValues);
//       }
//     } else {
//       const round = (val) => Math.round(val * 10) / 10;

//       const values = {
//         nasion: round(parseFloat(nasionToInion) * 0.1),
//         inion: round(parseFloat(nasionToInion) * 0.1),
//         fpz: round(parseFloat(nasionToInion) * 0.2),
//         fz: round(parseFloat(nasionToInion) * 0.2),
//         cz: round(parseFloat(nasionToInion) * 0.2),
//         pz: round(parseFloat(nasionToInion) * 0.2),
//         oz: round(parseFloat(nasionToInion) * 0.1),
//         t7: round(parseFloat(preauricular) * 0.1),
//         c3: round(parseFloat(preauricular) * 0.2),
//         c4: round(parseFloat(preauricular) * 0.2),
//         t8: round(parseFloat(preauricular) * 0.1),
//         c1: round(parseFloat(preauricular) * 0.2),
//         c2: round(parseFloat(preauricular) * 0.2),
//         fp1: round(parseFloat(circumference) * 0.05),
//         fp2: round(parseFloat(circumference) * 0.05),
//         f3: round(parseFloat(circumference) * 0.1),
//         f4: round(parseFloat(circumference) * 0.1),
//         f7: round(parseFloat(circumference) * 0.1),
//         f8: round(parseFloat(circumference) * 0.1),
//         p3: round(parseFloat(circumference) * 0.1),
//         p4: round(parseFloat(circumference) * 0.1),
//         p7: round(parseFloat(circumference) * 0.1),
//         p8: round(parseFloat(circumference) * 0.1),
//         o1: round(parseFloat(circumference) * 0.05),
//         o2: round(parseFloat(circumference) * 0.05),
//       };

//       setCalculatedValues(values);
//       setUpdateTimestamp(new Date().toLocaleString('en-US', {
//         timeZone: 'Asia/Kolkata',
//         year: 'numeric',
//         month: 'long',
//         day: 'numeric',
//         hour: 'numeric',
//         minute: 'numeric',
//         hour12: true,
//       }));
//       if (onCalculatedValues) {
//         onCalculatedValues(values);
//       }
//     }
//   }, [formData, onCalculatedValues]);

//   const pointMap = {
//     nasion: { top: 0.135, left: 0.507 },
//     fpz: { top: 0.265, left: 0.505 },
//     fz: { top: 0.445, left: 0.510 },
//     cz: { top: 0.610, left: 0.510 },
//     pz: { top: 0.785, left: 0.510 },
//     oz: { top: 0.925, left: 0.507 },
//     t7: { top: 0.530, left: 0.03 },
//     c3: { top: 0.530, left: 0.198 },
//     c4: { top: 0.530, left: 0.825 },
//     t8: { top: 0.530, left: 0.990 },
//     c1: { top: 0.530, left: 0.409 },
//     c2: { top: 0.530, left: 0.615 },
//     fp1: { top: 0.18, left: 0.440 },
//     fp2: { top: 0.18, left: 0.58 },
//     f3: { top: 0.242, left: 0.24 },
//     f4: { top: 0.245, left: 0.765 },
//     f7: { top: 0.422, left: 0.124 },
//     f8: { top: 0.423, left: 0.895 },
//     p3: { top: 0.812, left: 0.25 },
//     p4: { top: 0.812, left: 0.765 },
//     p7: { top: 0.638, left: 0.105 },
//     p8: { top: 0.635, left: 0.920 },
//     o1: { top: 0.875, left: 0.440 },
//     o2: { top: 0.875, left: 0.575 },
//   };

//   const handleImageLoad = (e) => {
//     const { width, height } = e.target;
//     setLayout({ width, height });
//   };

//   return (
//     <div className={!showInputs ? 'brain-section' : ''}>
//       {/* {updateTimestamp && (
//         <h5 className="text-center mb-2" style={{ color: 'red' }}>
//           Last Updated: {updateTimestamp}
//         </h5>
//       )} */}
//       <div className="brain-wrapper" style={{ position: 'relative' }}>
//         <Image
//           alt="Brain Diagram"
//           className="brain-image"
//           src={nomenclature === 0 ? T3T4Img : T7T8Img}
//           onLoad={handleImageLoad}
//         />
//         {layout.width > 0 &&
//           Object.entries(pointMap).map(([key, pos]) => (
//             <input
//               key={key}
//               type="text"
//               className={`distance-input pos-${key} ${calculatedValues[key] === 0.0 ? 'input-red' : ''}`}
//               value={calculatedValues[key] !== undefined ? calculatedValues[key].toFixed(1) : ''}
//               style={{
//                 position: 'absolute',
//                 top: `calc(${pos.top * 100}% - 4px)`,
//                 left: `calc(${pos.left * 100}% - 2px)`,
//               }}
//               readOnly
//             />
//           ))}
//       </div>
//     </div>
//   );
// };

// export default BrainDiagram;